import {
  GET_VPP_TEMPLATES,
  SET_VPP_TEMPLATES,
  GET_OS_LIST,
  SET_OS_LIST,
  GET_OS_VERSIONS,
  SET_OS_VERSIONS,
  GET_VM_DETAILS,
  SET_VM_DETAILS,
  GET_NIC_NETWORK,
  SET_NIC_NETWORK,
  GET_NIC_NETWORK_ADAPTER_TYPES,
  SET_NIC_NETWORK_ADAPTER_TYPES,
  PUBLISH_COURSE_DEFINITION,
  SAVE_UPDATE_COURSE_DEFINITION,
  SAVE_UPDATE_COURSE_DEF_SUCCESS,
  SAVE_UPDATE_COURSE_DEF_ERROR,
  GET_COURSE_DATA_BY_ID,
  GET_COURSE_DATA_BY_ID_SUCCESS,
  GET_COURSE_DATA_BY_ID_FAILURE,
  GET_ALL_VAPP_TEMPLATES_AND_VMS,
  SET_ALL_VAPP_TEMPLATES_AND_VMS,
  GET_NIC_IP_MODES,
  SET_NIC_IP_MODES,
  RESET_COURSE_CREATION_STATE,
  RESET_COURSE_DEF_DATA,
  VM_POWER_OFF_PROGRESS,
  VM_POWER_ON_PROGRESS,
  VM_POWER_ON_OFF,
  RESET_VM_POWER_OPERATION,
  TOKEN_GETTING_REFRESHED,
  MOUNT_ISO_ACADEMY,
  UN_MOUNT_ISO_ACADEMY,
  MOUNTING_IN_PROGRESS,
  UN_MOUNTING_IN_PROGRESS,
  RESET_MEDIA_OPERATION,
  RESET_UN_MOUNT_STATUS,
  RESET_MOUNT_STATUS,

} from "../utils/constants";

export const getvAppTemplatesList = () => ({
  type: GET_VPP_TEMPLATES,
});

export const setVmPowerOffProgress = (response: any) => ({
  type: VM_POWER_OFF_PROGRESS,
  response,
});

export const setVmPowerOnProgress = (response: any) => ({
  type: VM_POWER_ON_PROGRESS,
  response,
});

export const resetVmPowerOperation = () => ({
  type: RESET_VM_POWER_OPERATION,
});

export const insertingMedia = (response: any) => ({
  type: MOUNTING_IN_PROGRESS,
  response,
});

export const ejectingMedia = (response: any) => ({
  type: UN_MOUNTING_IN_PROGRESS,
  response,
});

export const resetMediaOperation = () => ({
  type: RESET_MEDIA_OPERATION,
});


export const vmPowerOnOff = (payload: any) => ({
  type: VM_POWER_ON_OFF,
  payload,
});

export const resetCourseDefData = () => ({
  type: RESET_COURSE_DEF_DATA,
});

export const mountISOFile = (payload: any) => ({
  type: MOUNT_ISO_ACADEMY,
  payload,
});

export const unMountISOFile = (payload: any) => ({
  type: UN_MOUNT_ISO_ACADEMY,
  payload,
});

export const resetMountStatus = () => ({
  type: RESET_MOUNT_STATUS,
});

export const resetUnMountStatus = () => ({
  type: RESET_UN_MOUNT_STATUS,
});

export const getosTypesList = () => ({
  type: GET_OS_LIST,
});

export const tokenGettingRefreshed = (response: any) => ({
  type: TOKEN_GETTING_REFRESHED,
  response,
});

export const setOSList = (response: any) => ({
  type: SET_OS_LIST,
  response,
});

export const getNicNetwork = () => ({
  type: GET_NIC_NETWORK,
});

export const setNicNetwork = (response: any) => ({
  type: SET_NIC_NETWORK,
  response,
});

export const getAllvAppTemplatesAndVms = (
  pageNo: number,
  pageSize: number,
  searchType?: string,
  searchQuery?: string,
  sortBy?: number,
  sortOrder?: number,
) => ({
  type: GET_ALL_VAPP_TEMPLATES_AND_VMS,
  pageNo,
  pageSize,
  searchType,
  searchQuery,
  sortBy,
  sortOrder,
});

export const setAllvAppTemplatesAndVms = (payload: any) => ({
  type: SET_ALL_VAPP_TEMPLATES_AND_VMS,
  payload,
});

export const getNicNetworkAdapterType = () => ({
  type: GET_NIC_NETWORK_ADAPTER_TYPES,
});

export const setNicNetworkAdapterType = (response: any) => ({
  type: SET_NIC_NETWORK_ADAPTER_TYPES,
  response,
});

export const getNicIpModes = () => ({
  type: GET_NIC_IP_MODES,
});

export const setNicIpModes = (response: any) => ({
  type: SET_NIC_IP_MODES,
  response,
});

export const getosVersionsList = (osId: string) => ({
  type: GET_OS_VERSIONS,
  osId,
});

export const setosVersionsList = (response: any) => ({
  type: SET_OS_VERSIONS,
  response,
});

export const setvAppTemplates = (response: any) => ({
  type: SET_VPP_TEMPLATES,
  response,
});

export const getVmDetails = (
  vAppTemplateId: string,
  pageNo: number,
  pageSize: number,
) => ({
  type: GET_VM_DETAILS,
  vAppTemplateId,
  pageNo,
  pageSize,
});

export const setVmDetails = (response: any) => ({
  type: SET_VM_DETAILS,
  response,
});

export const publishCourseDefinition = (payload: any) => ({
  type: PUBLISH_COURSE_DEFINITION,
  payload,
});

export const saveUpdateCourseDefinition = (
  payload: any,
  editMode: boolean,
) => ({
  type: SAVE_UPDATE_COURSE_DEFINITION,
  payload,
  editMode,
});

export const saveUpdateCourseDefSuccess = (response: any) => ({
  type: SAVE_UPDATE_COURSE_DEF_SUCCESS,
  response,
});

export const saveUpdateCourseDefFailure = (response: any) => ({
  type: SAVE_UPDATE_COURSE_DEF_ERROR,
  response,
});

export const resetCourseCreationState = () => ({
  type: RESET_COURSE_CREATION_STATE,
});

export const getCourseDataById = (courseId: any) => ({
  type: GET_COURSE_DATA_BY_ID,
  courseId,
});
export const getCourseDataByIdSuccess = (response: any) => ({
  type: GET_COURSE_DATA_BY_ID_SUCCESS,
  response,
});
export const getCourseDataByIdFailure = (response: any) => ({
  type: GET_COURSE_DATA_BY_ID_FAILURE,
  response,
});
